module.exports = __webpack_public_path__ + "static/media/login-logo.213272cf.png";